import Swiper from "SwiperLatest";
import {
    Pagination,
    Autoplay,
    Navigation,
    Scrollbar,
} from "SwiperLatest/modules/index.mjs";

new Swiper(".pickupSwiper", {
    slidesPerView: "auto",
    autoplay: {
        delay: 4000,
    },
    loop: true,
    speed: 1000,
    pagination: {
        el: ".swiper-pagination",
    },
    scrollbar: {
        el: ".swiper-scrollbar",
        draggable: true,
        dragSize: innerWidth * (28 / 393),
    },
    modules: [Pagination, Autoplay, Scrollbar],
});

const voiceSwiperCfg = {
    slidesPerView: "auto",
    navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
    },
    modules: [Navigation],
};

if (document.body.classList.contains("page-student")) {
    voiceSwiperCfg.centeredSlides = true;
    voiceSwiperCfg.breakpoints = {
        1025: {
            centeredSlides: false,
        },
    };
}

new Swiper(".VoiceSwiper", voiceSwiperCfg);
